import { Disclosure } from "@headlessui/react";
import clsx from "clsx";
import { motion } from "framer-motion";
import { ChevronRight } from "lucide-react";
import type { PropsWithChildren } from "react";

interface AccordionButtonProps extends PropsWithChildren<{}> {
	isOpen?: boolean;
	isSelected?: boolean;
	hasChildren?: boolean;
	className?: string;
	isCompleted?: boolean;
}

const AccordionButton = ({
	isOpen,
	children,
	hasChildren,
	isSelected,
	className,
	isCompleted,
}: AccordionButtonProps) => {
	return (
		<Disclosure.Button
			className={clsx(
				`mb-0 flex w-full items-center justify-between gap-1.5 rounded-lg px-3.5 py-2 hover:bg-sky-50/50 dark:text-gray-50 hover:dark:bg-slate-700/50`,

				isSelected
					? isCompleted
						? "bg-emerald-50 dark:bg-emerald-200/10"
						: "bg-sky-50 dark:bg-slate-700/60"
					: "",
				className,
			)}
			as={motion.button}
			layout="position"
		>
			<motion.span layout="position" className="w-full text-left">
				<>{children}</>
			</motion.span>

			{hasChildren && (
				<ChevronRight
					className={clsx(`-mr-0.5 transition-all dark:text-gray-50`, {
						"rotate-90": isOpen || isSelected,
					})}
					size={20}
				/>
			)}
		</Disclosure.Button>
	);
};

export default AccordionButton;
